// GlowStrike ES — product gallery: thumbnail click scrolls the main track, prev/next arrows
// step by one slide, thumbnail aria-current follows scroll position. Matches the competitor's
// initGallery() in theme.js (re-implemented from scratch, same behavior).
(function () {
  function showMedia(root, mediaId) {
    var track = root.querySelector('[data-gallery-track]');
    var slide = root.querySelector('[data-media-id="' + mediaId + '"]');
    if (track && slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }

  function initGallery(root) {
    var track = root.querySelector('[data-gallery-track]');
    if (!track || root.dataset.galleryReady) return;
    root.dataset.galleryReady = 'true';

    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(root, thumb.dataset.galleryThumb);
      });
    });

    function current() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function go(index) {
      var slide = slides[(index + slides.length) % slides.length];
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });

    var pending = null;
    track.addEventListener('scroll', function () {
      if (pending) window.cancelAnimationFrame(pending);
      pending = window.requestAnimationFrame(function () {
        var index = current();
        thumbs.forEach(function (thumb, n) {
          thumb.setAttribute('aria-current', String(n === index));
        });
        slides.forEach(function (slide, n) {
          if (n !== index) {
            var videos = slide.querySelectorAll('video');
            videos.forEach(function (v) { v.pause(); });
          }
        });
      });
    }, { passive: true });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-gallery]').forEach(initGallery);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
